import { gql } from "@apollo/client";

const GET_PAGES = gql`
  query getAllPages(
    $mainSuperAdminId: ID!
    $source: String!
    $onlySelected: Boolean
  ) {
    getAllPages(
      mainSuperAdminId: $mainSuperAdminId
      source: $source
      onlySelected: $onlySelected
    ) {
      success
      error
      result {
        id
        name
        pageId
        accesstoken
        picture
        isSelected
        email
        disabled
        waba_name
        wa_number
        waba_id
      }
    }
  }
`;
export default GET_PAGES;
